import {Renderer2} from '@angular/core';

export abstract class StyleService {
  abstract addClass(renderer: Renderer2, component: string, className: string);
  abstract removeClass(renderer: Renderer2, component: string, className: string);
}
